"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFacingWorkout = void 0;
const core = __importStar(require("../../core"));
exports.ClientFacingWorkout = core.serialization.object({
    userId: core.serialization.property("user_id", core.serialization.string()),
    id: core.serialization.string(),
    title: core.serialization.string().optional(),
    timezoneOffset: core.serialization.property("timezone_offset", core.serialization.number().optional()),
    averageHr: core.serialization.property("average_hr", core.serialization.number().optional()),
    maxHr: core.serialization.property("max_hr", core.serialization.number().optional()),
    distance: core.serialization.number().optional(),
    calendarDate: core.serialization.property("calendar_date", core.serialization.string()),
    timeStart: core.serialization.property("time_start", core.serialization.date()),
    timeEnd: core.serialization.property("time_end", core.serialization.date()),
    calories: core.serialization.number().optional(),
    sport: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(require("..")))).ClientFacingSport; })).optional(),
    hrZones: core.serialization.property("hr_zones", core.serialization.list(core.serialization.number()).optional()),
    movingTime: core.serialization.property("moving_time", core.serialization.number().optional()),
    totalElevationGain: core.serialization.property("total_elevation_gain", core.serialization.number().optional()),
    elevHigh: core.serialization.property("elev_high", core.serialization.number().optional()),
    elevLow: core.serialization.property("elev_low", core.serialization.number().optional()),
    averageSpeed: core.serialization.property("average_speed", core.serialization.number().optional()),
    maxSpeed: core.serialization.property("max_speed", core.serialization.number().optional()),
    averageWatts: core.serialization.property("average_watts", core.serialization.number().optional()),
    deviceWatts: core.serialization.property("device_watts", core.serialization.number().optional()),
    maxWatts: core.serialization.property("max_watts", core.serialization.number().optional()),
    weightedAverageWatts: core.serialization.property("weighted_average_watts", core.serialization.number().optional()),
    map: core.serialization.record(core.serialization.string(), core.serialization.unknown()).optional(),
    providerId: core.serialization.property("provider_id", core.serialization.string()),
    source: core.serialization.lazyObject(() => __awaiter(void 0, void 0, void 0, function* () { return (yield Promise.resolve().then(() => __importStar(require("..")))).ClientFacingSource; })),
});
